import { Row, Col, OverlayTrigger, Tooltip, Badge, Button, ButtonToolbar } from 'react-bootstrap';

import { format } from 'date-fns';

import { IcebergButton, IcebergIcon } from '@tradesolution/iceberg-ui-react';

import { EndringsMelding } from 'services/QAApi/types';
import { PickedEnhet } from 'components/EnhetTypeahead/types';

import { formatBehandlesAvItem } from '../../../../utils';

import Style from './index.module.css';
import { EnhetViewModel } from 'services/KjederegisteretAdminApi/EnhetApi/types';
import openInNewTab from 'utils/functions/openInNewTab';

interface Props {
  enhet: EnhetViewModel;
  erPublisert?: boolean;
  initialEnhetIsNotAktiv?: boolean;
  changeRequest: EndringsMelding;
  submitDisabled: boolean;
  submitLoading: boolean;
  folgesOppLoading: boolean;
  onFolgesOppClicked: () => void;
  onAvvisClicked: () => void;
  onIgnoreClicked: () => void;
  onSubmitClicked: () => void;
  onEnhetChange: (enhet: PickedEnhet) => void;
  onCloseWindowClicked: () => void;
}

const DetailStickyHeader = (props: Props) => {
  return (
    <div className={Style.headerContainer}>
      <Row className={Style.infoContainer}>
        <Col>
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip id="tooltip-behandles-av">
                <strong>Behandles av: </strong>
                {props.changeRequest.behandlesAv.length > 0
                  ? props.changeRequest.behandlesAv.map(formatBehandlesAvItem).join(', ')
                  : 'Ikke tildelt'}
              </Tooltip>
            }
          >
            <Badge bg="info" text="dark">
              <span>
                <IcebergIcon icon="user" />
                {props.changeRequest.behandlesAv.length > 0
                  ? props.changeRequest.behandlesAv.map(formatBehandlesAvItem)[0].split(' ')[0]
                  : 'Ikke tildelt'}
                {props.changeRequest.behandlesAv.length > 1 && (
                  <span>+{props.changeRequest.behandlesAv.length - 1}</span>
                )}
              </span>
            </Badge>
          </OverlayTrigger>
        </Col>
        <Col className="d-flex justify-content-end align-items-center">
          <ButtonToolbar className={Style.actionBtnToolbar}>
            <IcebergButton
              size="sm"
              variant="outline-primary"
              className="me-2"
              disabled={
                !!(
                  props.changeRequest.status === 'Avvist' ||
                  props.changeRequest.status === 'Behandlet'
                )
              }
              onClick={() => props.onFolgesOppClicked()}
              isLoading={props.folgesOppLoading}
            >
              <span>
                {props.changeRequest.status === 'FolgesOpp' ? 'Stans oppfølging' : 'Følg opp'}
              </span>
            </IcebergButton>
            <IcebergButton
              size="sm"
              variant="outline-primary"
              className="me-2"
              disabled={
                !!(
                  props.changeRequest.status === 'Avvist' ||
                  props.changeRequest.status === 'Behandlet'
                )
              }
              onClick={props.onAvvisClicked}
            >
              <span>Avvis </span>
            </IcebergButton>
            <IcebergButton
              size="sm"
              variant="outline-primary"
              className="me-2"
              disabled={
                !!(
                  props.changeRequest.status === 'Behandlet' ||
                  props.changeRequest.status === 'Avvist'
                )
              }
              onClick={props.onIgnoreClicked}
            >
              <span>Ignorer</span>
            </IcebergButton>
            <IcebergButton
              size="sm"
              variant="primary"
              disabled={props.submitDisabled}
              onClick={props.onSubmitClicked}
              isLoading={props.submitLoading}
            >
              <span>Lagre</span>
            </IcebergButton>
          </ButtonToolbar>
          <IcebergButton
            size="sm"
            icon="close"
            variant="outline-secondary"
            className="ms-2"
            onClick={props.onCloseWindowClicked}
          >
            Lukk
          </IcebergButton>
        </Col>
      </Row>
    </div>
  );
};

export default DetailStickyHeader;
